// extracted by extract-css-chunks-webpack-plugin
module.exports = {"policy-content":"show-policy-modal__policy-content--3OFQk","policyContent":"show-policy-modal__policy-content--3OFQk"};